import { useReadContract } from 'wagmi';

import { NFTMarket } from 'lib/abis/NFTMarket';
import { getContractAddress } from 'lib/addresses';

import { NftFilter } from 'types/Nft';

type Options = {
  enabled?: boolean;
};

export function useNftSeller(variables: NftFilter, options: Options = {}) {
  const { chainId, contractAddress, tokenId } = variables;

  return useReadContract({
    abi: NFTMarket,
    address: getContractAddress({
      chainId,
      contractName: 'nftMarket',
    }),
    chainId,
    functionName: 'getSellerOf',
    args: [contractAddress, BigInt(tokenId)],
    query: {
      enabled: options.enabled ?? true,
    },
  });
}
